<template>
	<div class="main-top">
		<home-nav></home-nav>

		<!-- Trazilica banner -->
		<section id="uvjeti-banner" class="uvjeti-banner-area">
			<div class="overlay overlay-bg"></div>
			<div class="container">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 uvjeti-banner-content">
						<div class="row">
							<div class="col-12">
								<h1 class="text-center">Izjava o privatnosti</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="my-5">
			<div class="container">
				<div class="row">
					<div class="col-md-12 text-justify">
						<p>FIGARO - obrt za usluge, vl. Tino Botić, Split (dalje u tekstu: voditelj obrade) kao voditelj obrade prikuplja Vaše osobne podatke u različite svrhe s ciljem prodaje proizvoda ili ugovaranja usluga, te se u prikupljanju i obradi Vaših podataka vodi načelom transparentnosti i sigurnosti.<br><br>

							Ova Izjava sastavljena je s ciljem ispunjavanja uvjeta u pogledu zakonitosti obrade osobnih podataka i drugih uvjeta utvrđenih i propisanih Uredbom (EU) 2016/679 Europskog parlamenta i vijeća o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (dalje u tekstu: Opća uredba o zaštiti podataka).<br>
							Ova Izjava o privatnosti primjenjuje se od 25. svibnja 2018. Molimo, pažljivo pročitajte ovaj dokument kako biste razumjeli kako voditelj obrade koristi i štiti Vaše osobne podatke.<br><br>

							<b>Korištenjem ovih internetskih stranica suglasni ste s načinom prikupljanja i obrade podataka opisanim u ovoj Izjavi o privatnosti.</b><br><br>

							Voditelj obrade zadržava pravo izmjene ove Izjave o privatnosti. Sve promjene biti će objavljene na internetskim stranicama voditelja obrade. Savjetujemo da povremeno provjerite postoje li eventualne izmjene ove Izjave kako biste bili informirani o svim promjenama.<br><br>

							<b>Koje informacije prikupljamo o vama i kako ih koristimo</b><br>
							Korištenje internetskih stranica voditelja obrade anonimno je i ne zahtijeva otkrivanje Vašeg identiteta ili drugih osobnih podataka. Općenito, možete posjetiti našu web stranicu bez otkrivanja osobnih podataka o sebi. Ne prikupljamo osobne podatke o vama kada posjetite ovu web stranicu, osim ako dobrovoljno ne pošaljete podatke pomoću jednog od dostupnih obrazaca za određenu svrhu (kontakt obrazac). Na pojedinim mjestima (kontakt obrazac), voditelj obrade može prikupljati i obrađivati Vaše osobne podatke kako bi omogućio pružanje svojih usluga. To može uključivati, ali nije ograničeno na sljedeće informacije:<br>
							- Identifikacijski podaci (prezime, ime)<br>
							- Kontakt podaci (adresa elektroničke pošte)<br><br>

							Obrada Vaših osobnih podataka koje nam dostavite putem kontakt obrasca temelji se na našem legitimnom interesu da nudimo naše usluge, za koje ste vi iskazali interes.<br><br>

							<b>Rok pohrane vaših osobnih podataka</b><br>
							Podatke pohranjujemo do ispunjenja svrhe njihova prikupljanja. To znači da ćemo izbrisati Vaše osobne podatke kada ti podaci više neće biti potrebni, odnosno podaci poslani u kontakt obrascu putem internetske stranice pohranjuju se do 90 dana.<br><br>

							<b>Sigurnost vaših osobnih podataka</b><br>
							Primijenili smo prikladne tehničke i organizacijske mjere kako bismo zaštitili Vaše osobne podatke od gubitka, krađe, nezakonitog pristupa ili sličnih incidenata. Broj osoba s pristupom Vašim osobnim podacima je ograničen i samo će ovlašteni zaposlenici voditelja obrade imati pristup Vašim osobnim podacima.<br>
							Voditelj obrade ne prodaje, iznajmljuje ili posuđuje osobne podatke korisnika internetskih stranica trećim stranama i štiti Vaše osobne podatke od neovlaštenog pristupa.<br><br>

							<b>Prava ispitanika</b><br>
							Sukladno poglavlju III. Opće uredbe o zaštiti osobnih podataka EU 679/2018. svoja prava kao ispitanik (pravo na pristup, pravo na ispravak, pravo na brisanje/zaborav, pravo na ograničenje obrade, pravo na prenosivost podataka, pravo na prigovor) možete ostvariti putem obrasca Zahtjev ispitanika koji možete preuzeti putem elektroničke pošte.<br><br>

							U slučaju da imate primjedbe na način obrade Vaših osobnih podataka od strane Voditelja obrade ili primjedbe na način obrade Vaše pritužbe, žaliti se možete izravno nadzornom tijelu (Agencija za zaštitu osobnih podataka) ili Voditelju obrade kontaktiranjem: telefonski +385 97 613 25 03 ili putem elektroničke pošte info@figaro.hr.</p>
					</div>
				</div>
			</div>
		</section>


		<home-footer></home-footer>
	</div>
</template>
<script>
	export default {
		name: 'home',
	mounted() {
            var section=this.$router.currentRoute.hash.replace("#", "");
            if (section)
                this.$nextTick(()=> window.document.getElementById(section).scrollIntoView());
        }
	}

</script>
